/** Sends firmware commands to reset drive-unit locator X/Y and yaw to zero. */
export function resetDriveUnitOrientation(): boolean {
  return window.robotService?.resetDriveUnitOrientation?.() ?? false;
}
